import Vue from 'vue'
// import * as Sentry from "@sentry/vue";
// import { Integrations } from "@sentry/tracing";

/**
 * In case jQuery didn't load properly with webpack,
 * try this code.
 */
 import $ from 'jquery';
 window.jQuery = $;
 window.$ = $;

import App from './App.vue'
import router from './router'
import store from './store/index';

import './assets/css/jigsaw.min.copy.css'

// import './assets/css/jigsaw.min.copy.css'
// import './assets/css/memory.css'
// import './assets/js/memory.js'

Vue.config.productionTip = false

// Sentry.init({
//   Vue,
//   dsn: "https://ea4e9e882a7348f9bbd612e6aa82371c@sentry.e-gostudio.com/16",
//   integrations: [new Integrations.BrowserTracing()],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

new Vue({
  router,
  store,
  render: h => h(App),

  // Watch for route changes to do access token validation
  watch: {
    $route (){
        validateState();
    }
  } 
}).$mount('#app')

/**
 * If app not started,
 * go to home screen.
 */
function validateState() {
  if ( store.getters['app/started'] == false )
    router.push('/preload')
}
validateState();
